// src/app/[lang]/components/DictionaryProvider.tsx
'use client';
import { createContext, useContext } from 'react';
import type { Dictionary } from '../types/dictionaries';

const DictCtx = createContext<Dictionary | null>(null);

export function DictionaryProvider({ dict, children }: { dict: Dictionary; children: React.ReactNode }) {
  return <DictCtx.Provider value={dict}>{children}</DictCtx.Provider>;
}

export function useDict() {
  const v = useContext(DictCtx);
  if (!v) throw new Error('useDict must be used inside DictionaryProvider');
  return v;
}